import styled from 'styled-components';

export const Td = styled.td`
    text-align: right;
`;

export const Th = styled.th`
  text-align: right;
`;
